import React, { useEffect } from 'react'
import PageHeader from '../../../components/pageHeader/PageHeader'
import { ILink } from '../../../types'
import { PATHS } from '../../../routes/Routes'
import { KiteGrid, KiteGridCell, KiteIcon, KiteTooltip } from '@kite/react-kite'
import { useLocation, useNavigate } from 'react-router-dom'
import ScheduleContentRemarks from './ScheduleContentRemarks'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux/Store'
import ExportScheduleContentsTable from './ExportScheduleContentsTable'
import { copyToClipBoard } from '../../../utils/utils'
import CustomToast from '../../../components/toast/CustomToast'

import './ScheduleContentStyles.scss'

const ExportScheduleContent = () => {
  const navigate = useNavigate()
  const [toastStatus, setToastStatus] = React.useState(false)
  const [toastMsg, setToastMsg] = React.useState('')
  const { state: scheduleData } = useLocation()
  const { contentsData = [] } = useSelector((state: RootState) => state.exportSchedulesData)
  const remarksData = (contentsData || []).filter((contentData) => contentData?.EventType == 'REM')

  const navLinks: ILink[] = [
    {
      label: 'Batch Activity',
      link: PATHS.BATCH_ACTIVITY,
    },
    {
      label: 'Export Schedules',
      link: PATHS.SCHEDULES_EXPORT,
    },
    {
      label: 'Export Content',
      link: PATHS.SCHEDULES_EXPORT,
    },
  ]
  useEffect(() => {
    // Check if its edit mode and row data exists or not
    if (!scheduleData) {
      navigate(PATHS.SCHEDULES_EXPORT)
    }
  }, [])

  const handleCopy = (data: string) => () => {
    copyToClipBoard(data)
    setToastStatus(true)
    setToastMsg('Copied')
  }

  const handleToastExpire = () => {
    setToastStatus(false)
    setToastMsg('')
  }

  return (
    <div className='page-container'>
      <div className='page-content'>
        <PageHeader header='Export Content' navLinks={navLinks}></PageHeader>
        <div className='setup-container'>
          <div className='grid-container'>
            <div className='each-row'>
              <KiteGrid>
                <KiteGridCell col={1}>
                  <div className='field'>
                    <div className='label'>Batch</div>
                    <div className='value'>{scheduleData?.BatchID}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={7}>
                  <div className='field'>
                    <div className='label'>Source</div>
                    <div className='value'>
                      <div>{scheduleData?.SourceTitle}</div>
                      <KiteTooltip
                        className='cell-file-path'
                        type='truncation'
                        id='kt1'
                        text='Click to copy'
                        direction='bottom'
                      >
                        <span onClick={handleCopy(scheduleData?.SourcePath)}>
                          <span>{scheduleData?.SourcePath}</span>
                          <span className='cell-icon'>
                            <KiteIcon icon='ki-copy' />
                          </span>
                        </span>
                      </KiteTooltip>
                    </div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={1}>
                  <div className='field'>
                    <div className='label'>File In</div>
                    <div className='value'>{scheduleData?.FileNameIn}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={1}>
                  <div className='field'>
                    <div className='label'>File Out</div>
                    <div className='value'>{scheduleData?.FileNameOut}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={1}>
                  <div className='field'>
                    <div className='label'>LOI</div>
                    <div className='value'>{scheduleData?.LOICount}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={1}>
                  <div className='field'>
                    <div className='label'>Exported</div>
                    <div className='value'>
                      <span
                        className={
                          scheduleData?.DidExport == '1'
                            ? 'import-export-status Completed'
                            : 'import-export-status Incomplete'
                        }
                      >
                        {scheduleData?.DidExport == '1' ? 'True' : 'False'}
                      </span>
                    </div>
                  </div>
                </KiteGridCell>
              </KiteGrid>
            </div>
            <div className='each-row'>
              <KiteGrid>
                <KiteGridCell col={1}>
                  <div className='field'>
                    <div className='label'>Net In</div>
                    <div className='value'>{scheduleData?.FromNetCode}</div>{' '}
                  </div>
                </KiteGridCell>
                <KiteGridCell col={2}>
                  <div className='field'>
                    <div className='label'>Net Out</div>
                    <div className='value'>{scheduleData?.ToNetCode}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={2}>
                  <div className='field'>
                    <div className='label'>Zone In</div>
                    <div className='value'>{scheduleData?.FromZoneCode}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={2}>
                  <div className='field'>
                    <div className='label'>Zone Out</div>
                    <div className='value'>{scheduleData?.ToZoneCode}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={2}>
                  <div className='field'>
                    <div className='label'>Video Type</div>
                    <div className='value'>{scheduleData?.VideoType}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={2}>
                  <div className='field'>
                    <div className='label'>Headend</div>
                    <div className='value'>{scheduleData?.HeadEnd}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={1}>
                  <div className='field'>
                    <div className='label'>Provider</div>
                    <div className='value'>{scheduleData?.Provider}</div>
                  </div>
                </KiteGridCell>
              </KiteGrid>
            </div>
            <div className='each-row'>
              <KiteGrid>
                <KiteGridCell col={3}>
                  <div className='field'>
                    <div className='label'>Download Start Time</div>
                    <div className='value'>{scheduleData?.DownloadStarted}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={3}>
                  <div className='field'>
                    <div className='label'>Download End Time</div>
                    <div className='value'>{scheduleData?.Downloaded}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={2}>
                  <div className='field'>
                    <div className='label'>Prefix</div>
                    <div className='value'>{scheduleData?.Prefix}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={2}>
                  <div className='field'>
                    <div className='label'>Suffix</div>
                    <div className='value'>{scheduleData?.Suffix}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={2}>
                  <div className='field'>
                    <div className='label'>Config Detail</div>
                    <div className='value'>{scheduleData?.CdID}</div>
                  </div>
                </KiteGridCell>
              </KiteGrid>
            </div>
            <div className='each-row'>
              <KiteGrid>
                <KiteGridCell col={8}>
                  <div className='field'>
                    <div className='label'>Destination Path</div>
                    <div className='value'>{scheduleData?.ExportFolderPath}</div>
                  </div>
                </KiteGridCell>
                <KiteGridCell col={4}>
                  <div className='field'>
                    <div className='label'>Verification Path</div>
                    <div className='value'>02</div>
                  </div>
                </KiteGridCell>
              </KiteGrid>
            </div>
            <ScheduleContentRemarks remarksData={remarksData} />
          </div>
        </div>
        <div className='setup-container secondary-container'>
          <h5>Content</h5>
          <ExportScheduleContentsTable />
        </div>
      </div>
      <CustomToast status={toastStatus} message={toastMsg} onExpire={handleToastExpire} />
    </div>
  )
}
export default ExportScheduleContent
